import { InputNumber } from 'antd';
import styled from 'styled-components';

export default styled(InputNumber)`
	// Add your styles here
`;
